module.exports = __webpack_public_path__ + "img/zj8.f22d4f5c.png";